import { Box, Grid } from "@mantine/core";
import { useLocation, useParams } from "react-router-dom";
import PackageForm from "./PackageForm";
import { useGetPackageLazyQuery } from "src/generated/graphql";
import { useEffect } from "react";
import InitialChargeList from "src/modules/InitialCharge/InitialChargeList";
import ServiceAllotmentList from "src/modules/ServiceAllotment/ServiceAllotmentList";
import ProductDetail from "src/modules/Package/ProductDetail";
import useWritePermission from "src/hooks/usePermission";
import { EMPLOYEE_ROLE_OBJ } from "src/utils/constants";

type IPackageDetail = {
  isOrg: boolean;
};

export default function PackageDetail({ isOrg }: IPackageDetail) {
  const { pkgId } = useParams<{ pkgId: string }>();
  const [getPackage, { data: packageData }] = useGetPackageLazyQuery();
  const isAllowWrite = useWritePermission(
    isOrg ? EMPLOYEE_ROLE_OBJ.orgPackages : EMPLOYEE_ROLE_OBJ.locPackages
  );

  useEffect(() => {
    refetchData();
  }, [pkgId]);

  const refetchData = () => {
    pkgId &&
      getPackage({
        variables: { id: pkgId },
        fetchPolicy: "network-only",
      });
  };

  return (
    <Grid sx={{ width: "100%", justifyContent: "center" }} gutterMd={"xl"}>
      <Grid.Col span={12} md={6}>
        <PackageForm
          packageData={packageData?.packageOne}
          isAllowWrite={isAllowWrite}
          isOrg={isOrg}
          refetchData={refetchData}
        />
        {/* <Box mt={"md"}>
          <ProductDetail
            productData={packageData?.packageOne?.product}
            isAllowWrite={isAllowWrite}
            isEditable={
              packageData?.packageOne?.isOrg
                ? packageData?.packageOne?.isOrg && isOrg
                : true
            }
          />
        </Box> */}
      </Grid.Col>

      <Grid.Col span={12} md={6}>
        <InitialChargeList
          sx={{ minHeight: "38vh" }}
          title={"Charges"}
          initialCharges={packageData?.packageOne?.initialCharges}
          isAllowWrite={isAllowWrite}
          isEditable={
            packageData?.packageOne?.isOrg
              ? packageData?.packageOne?.isOrg && isOrg
              : true
          }
        />

        <ServiceAllotmentList
          sx={{ minHeight: "38vh" }}
          title={"Allotments"}
          isGenericPackage={packageData?.packageOne?.isGeneric}
          packageLocations={packageData?.packageOne?.locations}
          Allotments={packageData?.packageOne?.initialAllotments}
          isAllowWrite={isAllowWrite}
          isEditable={
            packageData?.packageOne?.isOrg
              ? packageData?.packageOne?.isOrg && isOrg
              : true
          }
        />
      </Grid.Col>
    </Grid>
  );
}
